import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { StudentBlockUIService } from '@student/core/blockui/student-blockui.service';

@Component({
  standalone: false,
  selector: 'block-ui',
  templateUrl: './blockui.html',
  styleUrls: ['./blockui.css'],
})
export class BlockUIComponent implements OnInit, OnDestroy {
  /** When false, nothing is rendered — no invisible overlay on the page. */
  visible = false;

  private static readonly DEFAULT_AUTO_CLOSE_MS = 10000;
  private autoCloseTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private changeDRef: ChangeDetectorRef,
    private bks: StudentBlockUIService,
  ) {}

  ngOnInit(): void {
    this.bks.setBox(this);
  }

  ngOnDestroy(): void {
    this.clearAutoCloseTimer();
    this.bks.clearBox(this);
  }

  open(bool?: boolean): void {
    void bool;
    this.clearAutoCloseTimer();
    this.visible = true;
    this.scheduleAutoClose(BlockUIComponent.DEFAULT_AUTO_CLOSE_MS);
    this.changeDRef.detectChanges();
  }

  openWithTimeout(callback: any, owner: any): void {
    this.clearAutoCloseTimer();
    this.visible = true;
    this.changeDRef.detectChanges();
    this.autoCloseTimer = setTimeout(() => {
      this.autoCloseTimer = null;
      this.visible = false;
      this.changeDRef.detectChanges();
      if (callback != null && typeof callback === 'function') {
        callback.call(owner);
      }
    }, 3000);
  }

  openWithTimeoutWithTime(callback: any, owner: any, time: number): void {
    this.clearAutoCloseTimer();
    this.visible = true;
    this.changeDRef.detectChanges();
    const ms = Math.max(0, time) * 1000;
    this.autoCloseTimer = setTimeout(() => {
      this.autoCloseTimer = null;
      this.visible = false;
      this.changeDRef.detectChanges();
      if (callback != null && typeof callback === 'function') {
        callback.call(owner);
      }
    }, ms);
  }

  close(): void {
    this.clearAutoCloseTimer();
    if (!this.visible) {
      return;
    }
    this.visible = false;
    this.changeDRef.detectChanges();
  }

  private scheduleAutoClose(ms: number): void {
    this.autoCloseTimer = setTimeout(() => {
      this.autoCloseTimer = null;
      this.visible = false;
      this.changeDRef.detectChanges();
    }, ms);
  }

  private clearAutoCloseTimer(): void {
    if (this.autoCloseTimer != null) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }
}
